'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ErrorLabel = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\tmargin-top: ', 'px;\n'], ['\n\tmargin-top: ', 'px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../constants/sizes');

var _label = require('../text/label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ErrorLabel = exports.ErrorLabel = (0, _styledComponents2.default)(_label2.default)(_templateObject, (0, _getSize2.default)(_sizes.Sizes.xxs));

exports.default = ErrorLabel;